import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DonutViewByOption } from 'typings/viewBy'

const initialState: DonutViewByOption[] = []

const selectedDonutViewBySlices = createSlice({
  name: 'selectedDonutViewBy',
  initialState,
  reducers: {
    selectDonutViewBy(state, action: PayloadAction<DonutViewByOption>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
    setDonutViewBy(state, action: PayloadAction<DonutViewByOption[]>) {
      return action.payload ?? initialState
    },
  },
})

export const { selectDonutViewBy, setDonutViewBy } = selectedDonutViewBySlices.actions

export default selectedDonutViewBySlices.reducer
